import React, { useEffect, useState } from 'react';

function ModuleFeaturedCourse({
  _id,
  /* _contentTypeId,
  _href,
  _as, */
  title,
  course,
  className,
  themeClassName,
  // redux state
  completedCourseTopics,
  completedCourses,
  completedCoursesLoaded,
  completedCourseTopicsLoaded
}) {


  return (
   <></>
  );
}

export default ModuleFeaturedCourse;
